import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
export default function Avislist() {
  const [avis, setAvis] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedUnite, setSelectedUnite] = useState([]); // rendu multiple
  const [selectedRegion, setSelectedRegion] = useState([]); // rendu multiple
  const [showModal, setShowModal] = useState(false);
  const [showModalApprouver, setShowModalApprouver] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalAvis, setTotalAvis] = useState(0);
  const [filterStatus, setFilterStatus] = useState("");
  const [filterService, setFilterService] = useState("");
  const [filterUnite, setFilterUnite] = useState("");
  const [filterRegion, setFilterRegion] = useState("");
  const [dateFilter, setDateFilter] = useState("30days");
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [customDates, setCustomDates] = useState({ start: "", end: "" });

  const navigate = useNavigate();
  const API_BASE = "https://srv968119.hstgr.cloud";
  // Déterminer les services selon le type d'admin
  const getAvailableServices = () => {
    const adminType = localStorage.getItem("statu");
    if (adminType === "admin") {
      return ["GENDARMERIE", "POLICE", "DOUANE", "SNER"]; // Seul l'admin principal voit tous les services
    } else if (adminType === "admin_police") {
      return ["POLICE"]; // Admin police voit seulement police
    } else if (adminType === "admin_gendarmerie") {
      return ["GENDARMERIE"]; // Admin gendarmerie voit seulement gendarmerie
    } else {
      return [localStorage.getItem("service")]; // Autres utilisateurs voient seulement leur service
    }
  };
  
  const services = getAvailableServices();
  const unitesPolice = ["DPVN", "PJ", "UPR"];
  const regions = [
    "Agadez", "Diffa", "Dosso", "Maradi", "Niamey", "Tahoua", "Tillaberi", "Zinder"
  ];
  const limitOptions = [10, 50, 100, 500, 1000];



const handleServiceSelection = (service) => {
  setSelectedServices((prev) =>
    prev.includes(service) ? prev.filter((s) => s !== service) : [...prev, service]
  );
};

const handleUniteSelection = (unite) => {
  setSelectedUnite((prev) =>
    prev.includes(unite) ? prev.filter((u) => u !== unite) : [...prev, unite]
  );
};

const handleRegionSelection = (region) => {
  setSelectedRegion((prev) =>
    prev.includes(region) ? prev.filter((r) => r !== region) : [...prev, region]
  );
};
  const getDateRange = () => {
    const now = new Date();
    let startDate = null;
    let endDate = null;

    switch (dateFilter) {
      case "today":
        startDate = new Date(now.setHours(0, 0, 0, 0));
        endDate = new Date();
        break;
      case "yesterday":
        startDate = new Date(now);
        startDate.setDate(now.getDate() - 1);
        startDate.setHours(0, 0, 0, 0);
        endDate = new Date(startDate);
        endDate.setHours(23, 59, 59, 999);
        break;
      case "7days":
        startDate = new Date(now);
        startDate.setDate(now.getDate() - 7);
        startDate.setHours(0, 0, 0, 0);
        endDate = new Date();
        break;
      case "30days":
        startDate = new Date(now);
        startDate.setDate(now.getDate() - 30);
        startDate.setHours(0, 0, 0, 0);
        endDate = new Date();
        break;
      case "thismonth":
        startDate = new Date(now.getFullYear(), now.getMonth(), 1);
        endDate = new Date();
        break;
      case "lastmonth":
        startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        endDate = new Date(now.getFullYear(), now.getMonth(), 0);
        break;
      case "custom":
        startDate = customDates.start ? new Date(customDates.start) : null;
        endDate = customDates.end ? new Date(customDates.end) : null;
        break;
    }

    return { startDate, endDate };
  };

  const handleCustomDateSubmit = (e) => {
    e.preventDefault();
    setDateFilter("custom");
    setShowDatePicker(false);
    setPage(1);
  };

  const adminType = localStorage.getItem("statu"); // ou le champ qui correspond à ton type d'admin

  const fetchAvis = async () => {
    try {
      const { startDate, endDate } = getDateRange();

      let url = `${API_BASE}/avis?page=${page}&limit=${limit}`;

      if (searchTerm) url += `&search=${encodeURIComponent(searchTerm)}`;
      if (filterStatus) url += `&statut=${filterStatus}`;
      if (filterService) url += `&service_createur=${filterService}`;
      if (filterUnite) url += `&unite=${filterUnite}`;
      if (filterRegion) url += `&region=${filterRegion}`;
      if (startDate) url += `&date_debut=${startDate.toISOString()}`;
      if (endDate) url += `&date_fin=${endDate.toISOString()}`;
      if (adminType) url += `&admin_type=${adminType}`; // <-- AJOUT ICI

      const response = await fetch(url);
      const data = await response.json();

      setAvis(data.avis);
      setTotalPages(data.totalPages);
      setTotalAvis(data.totalAvis);
    } catch (error) {
      console.error("Erreur lors de la récupération des avis :", error);
    }
  };



  const approuver_avis = async (id) => {
    try {
      const response = await fetch(`${API_BASE}/avis/approuver_avis/${id}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          services: selectedServices,
          unite: selectedUnite,
          region: selectedRegion,
        }),
      });
      const data = await response.json();
      if (data) {
        fetchAvis();
      }
      setShowModalApprouver(false);
    } catch (error) {
      console.error("Erreur lors de l'approbation de l'avis :", error);
    }
  };

  const retirer_avis = async (id) => {
    try {
      await fetch(`${API_BASE}/avis/retirer_avis/${id}`);
      fetchAvis();
      setShowModal(false);
    } catch (error) {
      console.error("Erreur lors du retrait de l'avis :", error);
    }
  };

  const getPaginationNumbers = () => {
    let start = Math.max(1, page - 2);
    let end = Math.min(totalPages, start + 4);

    if (totalPages > 5 && end === totalPages) {
      start = Math.max(1, end - 4);
    }

    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  };

  useEffect(() => {
    fetchAvis();
  }, [searchTerm, page, limit, filterStatus, filterService, filterUnite, filterRegion, dateFilter, customDates]);

  return (
    <div className="px-3 sm:px-4 md:px-6 lg:px-8 py-4 bg-gray-100 dark:bg-gray-900 w-full flex flex-col rounded-xl">
      {/* Barre de filtres */}
      <div className="flex flex-wrap justify-between items-center mb-4 gap-2">
        <div className="flex flex-wrap gap-2">
          {/* Filtre par date */}
          <div className="dropdown z-40">
            <div tabIndex={0} role="button" className="btn">
              {{
                today: "Aujourd'hui",
                yesterday: "Hier",
                "7days": "7 derniers jours",
                "30days": "30 derniers jours",
                thismonth: "Ce mois-ci",
                lastmonth: "Mois précédent",
                custom: "Période perso"
              }[dateFilter] || "Filtrer par date"}
            </div>
            <ul tabIndex={0} className="dropdown-content menu shadow bg-base-100 rounded-box w-52">
              <li><button onClick={() => setDateFilter("today")}>Aujourd'hui</button></li>
              <li><button onClick={() => setDateFilter("yesterday")}>Hier</button></li>
              <li><button onClick={() => setDateFilter("7days")}>7 derniers jours</button></li>
              <li><button onClick={() => setDateFilter("30days")}>30 derniers jours</button></li>
              <li><button onClick={() => setDateFilter("thismonth")}>Ce mois-ci</button></li>
              <li><button onClick={() => setDateFilter("lastmonth")}>Mois précédent</button></li>
              <li><button onClick={() => setShowDatePicker(true)}>Période personnalisée</button></li>
            </ul>
          </div>

          {/* Filtre par statut */}
          <select
            className="select select-bordered"
            value={filterStatus}
            onChange={(e) => {
              setFilterStatus(e.target.value);
              setPage(1);
            }}
          >
            <option value="">Tous les statuts </option>
            <option value="0">En attente</option>
            <option value="1">Recherche en cours</option>
            <option value="2">Retrouvé</option>
          </select>

          {/* Filtre par service */}
          <select
            className="select select-bordered"
            value={filterService}
            onChange={(e) => {
              setFilterService(e.target.value);
              setPage(1);
            }}
          >
            <option value="">Tous les services</option>
            {services.map(service => (
              <option key={service} value={service}>{service}</option>
            ))}
          </select>

          {/* Sélecteur de nombre de lignes */}
          <div className="dropdown z-40">
            <div tabIndex={0} role="button" className="btn">
              {limit} lignes/page
            </div>
            <ul tabIndex={0} className="dropdown-content menu shadow bg-base-100 rounded-box w-40">
              {limitOptions.map(option => (
                <li key={option}>
                  <button onClick={() => {
                    setLimit(option);
                    setPage(1);
                  }}>
                    {option} lignes
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Date picker personnalisé */}
          {showDatePicker && (
            <div className="absolute z-50 mt-12 bg-white dark:bg-gray-700 p-4 rounded shadow-lg">
              <form onSubmit={handleCustomDateSubmit}>
                <div className="grid grid-cols-2 gap-2 mb-2">
                  <div>
                    <label className="block text-sm">Date de début</label>
                    <input
                      type="date"
                      className="input input-bordered w-full"
                      value={customDates.start}
                      onChange={(e) => setCustomDates({...customDates, start: e.target.value})}
                    />
                  </div>
                  <div>
                    <label className="block text-sm">Date de fin</label>
                    <input
                      type="date"
                      className="input input-bordered w-full"
                      value={customDates.end}
                      onChange={(e) => setCustomDates({...customDates, end: e.target.value})}
                    />
                  </div>
                </div>
                <div className="flex justify-end gap-2">
                  <button
                    type="button"
                    className="btn btn-ghost"
                    onClick={() => setShowDatePicker(false)}
                  >
                    Annuler
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Valider
                  </button>
                </div>
              </form>
            </div>
          )}
        </div>
      </div>

      {/* Barre de recherche */}
      <div className="relative mb-4">
        <input
          type="text"
          placeholder="Rechercher un avis..."
          className="input input-bordered w-full"
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setPage(1);
          }}
        />
        <div className="absolute right-3 top-3">
          <span className="badge badge-ghost">
            {totalAvis} résultats
          </span>
        </div>
      </div>

      {/* Tableau des avis */}
      <div className="overflow-x-auto overflow-y-auto h-[28rem] bg-base-100 rounded-xl shadow border border-base-200">
        <table className="table table-zebra w-full">
          <thead className="sticky top-0 z-10">
            <tr className="bg-base-200 text-xs sm:text-sm">
              <th className="whitespace-nowrap">FRANCHISE</th>
              <th className="whitespace-nowrap">MOTIF</th>
              <th className="whitespace-nowrap">STATUT</th>
              <th className="hidden sm:table-cell whitespace-nowrap">URGENCE</th>
              <th className="hidden md:table-cell whitespace-nowrap">SERVICES</th>
              <th className="whitespace-nowrap">ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            {avis.map((avis) => (
              <tr key={avis.id_avis} className="hover text-xs sm:text-sm">
                <td>{avis.franchise?.toUpperCase()}</td>
                <td className="max-w-xs sm:max-w-sm md:max-w-md truncate">{avis.motif?.toUpperCase()}</td>
                <td>
                  {avis.statu === "0" ? (
                    <span className="badge badge-warning font-bold text-white">ATTENTE</span>
                  ) : avis.statu === "1" ? (
                    <span className="badge badge-error font-bold text-white">RECHERCHE</span>
                  ) : (
                    <span className="badge badge-success font-bold text-white">RETROUVÉ</span>
                  )}
                </td>
                <td className="hidden sm:table-cell">
                  {avis.urgence !== "oui" ? (
                    "CLASSIQUE"
                  ) : (
                    <span className="text-red-500 font-bold">URGENT</span>
                  )}
                </td>
                <td className="hidden md:table-cell">
                  {avis.service_createur
                    ? avis.service_createur
                        .split(',')
                        .map(s => (
                          <span key={s} className="badge badge-info mr-1">{s.trim().toUpperCase()}</span>
                        ))
                    : "N/A"}
                </td>
                <td>
                  <div className="flex gap-2">
                    <button
                      className="btn btn-xs sm:btn-sm btn-error"
                      onClick={() => {
                        setSelectedId(avis.id_avis);
                        setShowModal(true);
                      }}
                    >
                      RETIRER
                    </button>
                    {avis.statu == 0 && (
                      <button
                        className="btn btn-xs sm:btn-sm btn-success"
                        onClick={() => {
                          setSelectedId(avis.id_avis);
                          setShowModalApprouver(true);
                        }}
                      >
                        APPROUVER
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex justify-center mt-4">
        <div className="join">
          <button
            className="join-item btn"
            disabled={page === 1}
            onClick={() => setPage(p => p - 1)}
          >
            «
          </button>

          {getPaginationNumbers().map(num => (
            <button
              key={num}
              className={`join-item btn ${page === num ? 'btn-active' : ''}`}
              onClick={() => setPage(num)}
            >
              {num}
            </button>
          ))}

          <button
            className="join-item btn"
            disabled={page === totalPages}
            onClick={() => setPage(p => p + 1)}
          >
            »
          </button>
        </div>
      </div>

      {/* Modales */}
      {showModal && (
        <div className="modal modal-open">
          <div className="modal-box">
            <h3 className="font-bold text-lg">CONFIRMER LE RETRAIT</h3>
            <p className="py-4">ÊTES-VOUS SÛR DE VOULOIR RETIRER CET AVIS ?</p>
            <div className="modal-action">
              <button className="btn" onClick={() => setShowModal(false)}>
                ANNULER
              </button>
              <button className="btn btn-error" onClick={() => retirer_avis(selectedId)}>
                CONFIRMER
              </button>
            </div>
          </div>
        </div>
      )}

      {showModalApprouver && (
        <div className="modal modal-open">
          <div className="modal-box">
            <h3 className="font-bold text-lg">APPROUVER L'AVIS</h3>
            <p className="py-2">SÉLECTIONNEZ LES SERVICES À NOTIFIER :</p>
            <div className="space-y-2 my-4">
              {services.map((service) => (
                <label key={service} className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    className="checkbox"
                    checked={selectedServices.includes(service)}
                    onChange={() => handleServiceSelection(service)}
                  />
                  <span className="uppercase">{service}</span>
                </label>
              ))}
            </div>
            
            {/* Option pour sélectionner tous les services (seulement pour l'admin principal) */}
            {localStorage.getItem("statu") === "admin" && (
              <div className="my-4">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    className="checkbox"
                    checked={selectedServices.length === services.length}
                    onChange={() => {
                      if (selectedServices.length === services.length) {
                        setSelectedServices([]);
                      } else {
                        setSelectedServices([...services]);
                      }
                    }}
                  />
                  <span className="uppercase font-bold">TOUS LES SERVICES</span>
                </label>
              </div>
            )}

            {/* Sélection multiple des unités, seulement si le service "police" est sélectionné */}
            {selectedServices.includes("POLICE") && (
              <div className="my-4">
                <label className="block text-sm font-medium uppercase">SÉLECTIONNEZ LES UNITÉS :</label>
                <div className="space-y-2 mt-2">
                  {unitesPolice.map((unite) => (
                    <label key={unite} className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="checkbox"
                        className="checkbox"
                        checked={selectedUnite.includes(unite)}
                        onChange={() => handleUniteSelection(unite)}
                      />
                      <span className="uppercase">{unite}</span>
                    </label>
                  ))}
                </div>
              </div>
            )}

            {/* Sélection multiple des régions */}
            <div className="my-4">
              <label className="block text-sm font-medium uppercase">SÉLECTIONNEZ LES RÉGIONS :</label>
              <div className="space-y-2 mt-2">
                {regions.map((region) => (
                  <label key={region} className="flex items-center gap-2 cursor-pointer">
                    <input
                      type="checkbox"
                      className="checkbox"
                      checked={selectedRegion.includes(region)}
                      onChange={() => handleRegionSelection(region)}
                    />
                    <span className="uppercase">{region}</span>
                  </label>
                ))}
              </div>
            </div>

            <div className="modal-action">
              <button className="btn" onClick={() => setShowModalApprouver(false)}>
                ANNULER
              </button>
              <button className="btn btn-success" onClick={() => approuver_avis(selectedId)}>
                CONFIRMER
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
